/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlayslipMessageCatalogEntry } from './PlayslipMessageCatalogEntry';
import {
    PlayslipMessageCatalogEntryFromJSON,
    PlayslipMessageCatalogEntryFromJSONTyped,
    PlayslipMessageCatalogEntryToJSON,
} from './PlayslipMessageCatalogEntry';

/**
 * Every piece of playslip copy a customer may reword, for the back office.
 * @export
 * @interface GetPlayslipMessageCatalogResponse
 */
export interface GetPlayslipMessageCatalogResponse {
    /**
     * 
     * @type {Array<PlayslipMessageCatalogEntry>}
     * @memberof GetPlayslipMessageCatalogResponse
     */
    items: Array<PlayslipMessageCatalogEntry>;
}

/**
 * Check if a given object implements the GetPlayslipMessageCatalogResponse interface.
 */
export function instanceOfGetPlayslipMessageCatalogResponse(value: object): value is GetPlayslipMessageCatalogResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetPlayslipMessageCatalogResponseFromJSON(json: any): GetPlayslipMessageCatalogResponse {
    return GetPlayslipMessageCatalogResponseFromJSONTyped(json, false);
}

export function GetPlayslipMessageCatalogResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPlayslipMessageCatalogResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(PlayslipMessageCatalogEntryFromJSON)),
    };
}

export function GetPlayslipMessageCatalogResponseToJSON(value?: GetPlayslipMessageCatalogResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map(PlayslipMessageCatalogEntryToJSON)),
    };
}

